<template>
    <div class="row">
        <div class="col-12">
            <LocationData
                v-if="$store.getters['CreateAudienceStore/getAnalysesCrossVisitationStatus']"
                :data-set-order="analysis_type.toLowerCase()"
                :analysis-type="analysis_type"
                :row-style="rowStyle"
            ></LocationData>

            <Filters
                v-if="$store.getters['CreateAudienceStore/getAnalysesCrossVisitationStatus']"
                :data-set-order="analysis_type.toLowerCase()"
                :analysis-type="analysis_type"
                :row-style="rowStyle"
            ></Filters>

            <Recency
                v-if="$store.getters['CreateAudienceStore/getAnalysesCrossVisitationStatus']"
                :data-set-order="analysis_type.toLowerCase()"
                :analysis-type="analysis_type"
                :row-style="rowStyle"
            ></Recency>

            <Limits
                v-if="$store.getters['CreateAudienceStore/getAnalysesCrossVisitationStatus']"
                :data-set-order="analysis_type.toLowerCase()"
                :analysis-type="analysis_type"
                :row-style="rowStyle"
            ></Limits>

            <div class="row" :style="rowStyle">
                <div class="form-inline col-md-2">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                icon
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="grey lighten-1" class="tooltip-small">
                                    mdi-information-outline
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Turn this on if you would like the exported data to be based on location hierarchy instead of brand hierarchy.</span>
                    </v-tooltip>

                    <i class="fas fa-location-arrow"></i> <span style="padding-left: 5px;">Cross Visitation </span>
                </div>
                <div class="form-group col-md-4 push-down-36">
                    <v-switch
                        v-model="poi_location_level"
                        inset
                        label="POI Location level"
                    ></v-switch>
                </div><!--form-group-->
            </div>
        </div>
    </div>
</template>

<script>
import analyses from "../../../../../mixin/analyses";
import LocationData from "../../poi/LocationData";
import Filters from "../Filters";
import Recency from "../Recency";
import Limits from "../Limits";

export default {
    name: "CrossVisitation",
    components: {Limits, Recency, Filters, LocationData},
    mixins: [analyses],
    props: [
        'rowStyle'
    ],
    data: () => ({
        analysis_type: 'Cross'
    }),
    methods: {
        //
    },
    created() {
        //
    },
    mounted() {
        //
    },
    computed: {
        poi_location_level: {
            get() {
                return this.$store.getters['CreateAudienceStore/getAnalysesCrossVisitationPoiLocationLevel']
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_ANALYSES_CROSS_VISITATION_POI_LOCATION_LEVEL', value)
            }
        }
    },
    watch: {
        //
    }
}
</script>

<style scoped>

</style>